var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-4"},[_c('h1',[_vm._v("Page not found :(")]),_c('router-link',{staticClass:" m-2 btn btn-primary",attrs:{"to":{ path: '/'},"type":"button"}},[_vm._v("Home")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }